// Lavet af Christian Andrés (15-10-2026) - projekt: pagespeed (v3) - C1: emballageafgift
// Afgiften (5 kr) ligger i kurven med præcis 1 stk., når der er mindst én anden vare, og fjernes, når der ikke er.
// /cart/update.js sætter et fast antal, så flere faner eller hurtige klik aldrig giver afgiften to gange.
// Før: afgiften blev lagt i kurven hos alle besøgende ved hver sidevisning (kurv-ikon viste "1", og "læg i kurv"-tracking blev forkert).
const PACKAGING_FEE_VARIANT_ID = 54971120746878;
// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.2) - gaveindpakningen (assets/gift-wrapping.js) tæller ikke som en vare.
// Før kunne en kurv ende med kun afgift + indpakning, når den sidste rigtige vare blev fjernet.
// Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.3) - audit 28: skal ændres sammen med VARIANT_ID i assets/gift-wrapping.js
const GIFT_WRAP_VARIANT_ID = 48889375818032;

async function syncPackagingFee() {
  try {
    // Lavet af Christian Andrés (21-10-2026) - projekt: pagespeed (v3.9) - tom kurv: højst 15 sek. pr. kald (som assets/gift-wrapping.js), så et hængende kald ikke låser gaveindpakningens kø
    const signal = AbortSignal.timeout ? AbortSignal.timeout(15000) : undefined;
    const cartResponse = await fetch('/cart.js', { signal, headers: { Accept: 'application/json' } });
    if (!cartResponse.ok) throw new Error(`Failed to fetch cart: ${cartResponse.status}`);
    const cart = await cartResponse.json();

    let feeQuantity = 0;
    let hasOtherItems = false;
    cart.items.forEach((item) => {
      if (item.variant_id === PACKAGING_FEE_VARIANT_ID) feeQuantity += item.quantity;
      else if (item.variant_id !== GIFT_WRAP_VARIANT_ID) hasOtherItems = true;
    });

    const wantedQuantity = hasOtherItems ? 1 : 0;
    if (feeQuantity === wantedQuantity) return;

    const updateResponse = await fetch('/cart/update.js', {
      signal: AbortSignal.timeout ? AbortSignal.timeout(15000) : undefined,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates: { [PACKAGING_FEE_VARIANT_ID]: wantedQuantity },
        sections: 'cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    });
    if (!updateResponse.ok) throw new Error(`Failed to update packaging fee: ${updateResponse.status}`);
    const updatedCart = await updateResponse.json();

    // Kurvsiden har sin egen opsummering (main-cart-footer), så den genindlæses for at vise det rigtige.
    // Kun hvis afgiften faktisk står rigtigt bagefter (fx udsolgt variant) - ellers ville siden genindlæse i ring.
    const newFeeQuantity = (updatedCart.items || [])
      .filter((item) => item.variant_id === PACKAGING_FEE_VARIANT_ID)
      .reduce((sum, item) => sum + item.quantity, 0);
    if (window.routes && window.location.pathname === window.routes.cart_url && newFeeQuantity === wantedQuantity) {
      window.location.reload();
      return;
    }

    // Kurv-ikonets tal
    const bubble = document.getElementById('cart-icon-bubble');
    const bubbleHtml = updatedCart.sections && updatedCart.sections['cart-icon-bubble'];
    if (bubble && bubbleHtml) {
      const section = new DOMParser().parseFromString(bubbleHtml, 'text/html').querySelector('.shopify-section');
      if (section) bubble.innerHTML = section.innerHTML;
    }

    // "Tom kurv"-tilstanden i kurv-skuffen (samme klasser som assets/cart.js sætter)
    // Lavet af Christian Andrés (16-10-2026) - projekt: pagespeed (v3.2) - tom, når der ingen rigtige varer er (en gaveindpakning, der er ved at blive fjernet, tæller ikke)
    const isEmpty = !hasOtherItems;
    document.querySelectorAll('cart-drawer, cart-drawer-items').forEach((el) => el.classList.toggle('is-empty', isEmpty));

    // Får kurv-skuffen til at hente varer og total igen, så afgiften vises med det samme
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'packaging-fee' });
    }
  } catch (error) {
    console.error('Error in syncPackagingFee:', error);
  }
}

// Kørslerne sættes i kø, så to synkroniseringer aldrig overlapper (ellers kan et gammelt svar overskrive et nyt)
// Lavet af Christian Andrés (21-10-2026) - projekt: pagespeed (v3.9) - tom kurv: samme kø som gaveindpakningen (cartStateQueue i assets/gift-wrapping.js).
// Når den sidste vare blev fjernet, fjernede de to scripts afgift og indpakning samtidig, og Shopify mistede den ene ændring. Så lå afgiften (5 kr) alene tilbage i kurven
let packagingFeeQueue = Promise.resolve();
function queuePackagingFeeSync() {
  if (typeof cartStateQueue !== 'undefined') {
    cartStateQueue = cartStateQueue.then(syncPackagingFee);
    return cartStateQueue;
  }
  packagingFeeQueue = packagingFeeQueue.then(syncPackagingFee);
  return packagingFeeQueue;
}

document.addEventListener('DOMContentLoaded', function () {
  queuePackagingFeeSync();
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'packaging-fee') return;
      queuePackagingFeeSync();
    });
  }
});
